module.exports = __webpack_public_path__ + "static/media/pineapple.d8c91125.svg";